import { useEffect } from "react";

/**
 * @param activeIndex
 * @param containerSelector
 * @param itemSelector
 */
export const useScrollIntoView = (
  activeIndex: number | null,
  containerSelector: string,
  itemSelector: string,
) => {
  useEffect(() => {
    if (activeIndex === null || activeIndex === -1) return;
    const container = document.querySelector(containerSelector);
    const highlighted = container?.querySelector(itemSelector);
    if (highlighted) {
      highlighted.scrollIntoView({ block: "nearest", behavior: "auto" });
    }
  }, [activeIndex, containerSelector, itemSelector]);
};
